// src/CrashTest.tsx
const CrashTest = () => {
  throw new Error("Test crash");
};

export default CrashTest;
